var jade = require("D:\\Jenkins670\\workspace\\D_PIPELINE_release_661166.5.70.0\\JAVA\\ui\\group_ui\\node_modules\\jade\\lib\\runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (employeeGroups, i18nContext, id, inputName, mountOn, readOnly, undefined) {
buf.push("<div" + (jade.attr("id", mountOn, true, true)) + " class=\"form-group form-group--row\">");
var i18nPrefix = (i18nContext) ? i18nContext : "details.policy."
buf.push("<label" + (jade.attr("for", id, true, true)) + (jade.attr("data-i18n", i18nPrefix + "employeeGroup", true, true)) + " class=\"half mobile-text-indent copy3 employee-group-text\">What Vhi employee group do you belong to?</label><div class=\"half\"><div class=\"select-container\">");
var attr = (readOnly) ? { disabled: "" } : {};
if (!readOnly) {
buf.push("<span class=\"di-support-text employee-group-support-label\">Select from the dropdown</span>");
}
var name = (inputName) ? inputName : "policyInfo.basicPolicyInfo.employeeGroup"
buf.push("<select" + (jade.attrs(jade.merge([{"id": jade.escape(id),"name": jade.escape(name),"data-style": "select-container__button","required": true,"data-i18n": (typeof (jade_interp = "[data-msg]" + i18nPrefix + "employeeGroup-msg") == "string" ? jade.escape(jade_interp) : jade_interp),"class": "form-control selectpicker"},attr]), true)) + "><option value=\"\">Please select</option>");
// iterate employeeGroups
;(function(){
  var $$obj = employeeGroups;
  if ('number' == typeof $$obj.length) {

    for (var groupId = 0, $$l = $$obj.length; groupId < $$l; groupId++) {
      var groupName = $$obj[groupId];

buf.push("<option" + (jade.attr("value", groupId, true, true)) + ">" + (jade.escape(null == (jade_interp = groupName) ? "" : jade_interp)) + "</option>");
    }

  } else {
    var $$l = 0;
    for (var groupId in $$obj) {
      $$l++;      var groupName = $$obj[groupId];

buf.push("<option" + (jade.attr("value", groupId, true, true)) + ">" + (jade.escape(null == (jade_interp = groupName) ? "" : jade_interp)) + "</option>");
    }

  }
}).call(this);

buf.push("</select></div></div></div>");}.call(this,"employeeGroups" in locals_for_with?locals_for_with.employeeGroups:typeof employeeGroups!=="undefined"?employeeGroups:undefined,"i18nContext" in locals_for_with?locals_for_with.i18nContext:typeof i18nContext!=="undefined"?i18nContext:undefined,"id" in locals_for_with?locals_for_with.id:typeof id!=="undefined"?id:undefined,"inputName" in locals_for_with?locals_for_with.inputName:typeof inputName!=="undefined"?inputName:undefined,"mountOn" in locals_for_with?locals_for_with.mountOn:typeof mountOn!=="undefined"?mountOn:undefined,"readOnly" in locals_for_with?locals_for_with.readOnly:typeof readOnly!=="undefined"?readOnly:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./src/shared/jade/templates/employeeGroupSelect.jade
// module id = fJHJ
// module chunks = 2